import React, { FC, useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";

import {
  AEABatchGrid,
  AEAField,
  AEATab,
  AEATabs,
  ExpectedResult
} from "@components/";
import { FormProaFEPresenter } from "@presenters/screens/form-proa-fe.presenter";
import { IFEStep4Dto } from "@models/*";
import { Utilities, String, Enums } from "@utils";
import AEATitle from "@/components/ui/aea-title/aea-title";
import ErrorTable from '@/components/ui/aea-error-table/aea-error-table';
import { Toast } from "devextreme-react/toast";
import styles from "../../form-proa-subproject-fe.module.scss";
export interface IGeneralData {
  tabIndex: number;
  subventionCodeId: number;
  objIndex: number;
  dataColumns: any;
  stepData: IFEStep4Dto[];
  startDate: any;
  endDate: any;
  readOnly: any;
  alertEndDate: boolean;
  showAlerts: boolean;
  handleSwitch?(): void;
  setStepData(data: any): void;
}

const GeneralData: FC<IGeneralData> = (props) => {
  const [objetivesIndicatorGridData, setObjetivesIndicatorGridData] = useState(null);
  const [modalExcel, setModalExcel] = useState<boolean>(false);
  const [gridDataExcel, setGridDataExcel] = useState(null);

  const [objData, setObjData] = useState(null);
  const [resData, setResData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [Alerts, setAlerts] = useState(false);

  const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		message: "",
	});

  const handleLoad = () => {
    props.handleSwitch()
    setAlerts(true)
  }

  const presenter = new FormProaFEPresenter({
    state: {
      index: props.objIndex,
      dataColumns: props.dataColumns,
      subventionCodeId: props.subventionCodeId,
      objetivesIndicatorGridData: objetivesIndicatorGridData,
      step4Data: props.stepData,
      readOnly: props.readOnly,
      modalExcel,
      setObjetivesIndicatorGridData: setObjetivesIndicatorGridData,
      setStep4Data: props.setStepData,
      setModalExcel,
      setGridDataExcel
    },
    startDate: props.startDate,
    endDate: props.endDate,
    setPartialSave: props.setStepData,
    handleLoad: handleLoad
  });

  useEffect(() => {        
    setObjetivesIndicatorGridData(null);
    setRefresh(refresh => !refresh)
  }, [props.startDate, props.endDate])

  useEffect(() => {
    presenter.initializeStep4GenericData(props.tabIndex, props.objIndex);
  }, [props.stepData?.[props.objIndex]?.objetives, refresh]);

  useEffect(() => {
    if (!Utilities.isNullEmptyObject(objetivesIndicatorGridData)) getObjData()
  }, [props.stepData, props.stepData?.[props.objIndex]?.objetives, objetivesIndicatorGridData, modalExcel, gridDataExcel, Alerts])

  useEffect(() => {
    if (!Utilities.isNullEmptyObject(props?.stepData?.[props.objIndex]?.results)) getResData()
  }, [props.stepData, props?.stepData?.[props.objIndex]?.results, objetivesIndicatorGridData, modalExcel, gridDataExcel])

  const handleChange = (option: any) => {
    let message = presenter.handleChangeValue(option)
    if(!message) message = presenter.handleChangeValueObjRes(option)

    if(!!message){
      setToastConfig({
        isVisible: true,
        type: 'info',
        message
      })
    }
  }

  const onHidingToast = () => {
      setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const getObjData = () => {
    setObjData(
      <Row>
        <Col>
          <AEABatchGrid {...objetivesIndicatorGridData} handleChange={handleChange} checkContent currentData={!!props.stepData?.[props.objIndex]?.objetives} modalExcel={modalExcel} gridDataExcel={gridDataExcel} presenter={presenter} onCellPreRender={presenter.onCellPreRender}></AEABatchGrid>
        </Col>
      </Row>
    )
  }

  const getResData = () => {
    setResData(
      <Row>
        <Col>{resultTab(props.stepData[props.objIndex].results)}</Col>
      </Row>
    )
  }

  const headerObj = () => {
    if (!Utilities.isNullEmptyObject(props.stepData)){
      return (
        <Row>
          <Col>
            <AEAField {...presenter.especificObjetive}></AEAField>
            <div className={styles.containerButtons}>
              {!props.readOnly ? (
                  <Button onClick={() => {
                    setTimeout(() => {
                        presenter.saveGenericInfoObjetiveStep4(props.tabIndex, props.objIndex)
                    },500)}
                    }>
                    Guardar Objetivo
                  </Button>
                ) : null}
              
            </div>
          </Col>
        </Row>
      );
    }
  };

  const resultsAction = () => {
    return (
      <Row>
        <Col xs="12" sm="12" md="8" xl="8">
          <AEATitle
            id={"ResultadosEsperados_" + props.tabIndex + "_" + props.objIndex}
            text={presenter.currentLabels.get("ResultadosEsperados")}
            tooltip={presenter.currentLabels.get("ResultadosEsperados")}
            placement={"auto"}
          ></AEATitle>
        </Col>
        {!props.readOnly ? (
          <Col xs="12" sm="12" md="4" xl="4">
            <div className={styles.containerButtons}>
              <Button
              onClick={(e) => {
                e.preventDefault();
                presenter.addNewExpectedResult();
              }}
            >
              {presenter.currentLabels.get("AddExpectedResult")}
            </Button>
            </div>
          </Col>
        ) : (
          <div></div>
        )}
      </Row>
    );
  };

  const resultTab = (results: any) => {
    if (results.length > 0) {
      return (
        <AEATabs defaultTab={0}>
          {results.map((item: any, index: number) => {
            const name = presenter.currentLabels.get("ResultadosEsperados");
            const key = String.Format(
              "T{0}O{1}R{2}",
              props.tabIndex,
              props.objIndex,
              index
            );
            return (
              <AEATab key={key} title={name + (index + 1)} active={index === 0}>
                <br />
                <ExpectedResult
                  handleSwitch={props.handleSwitch}
                  alertEndDate={props.alertEndDate}
                  showAlerts={props.showAlerts} 
                  subventionCodeId={props.subventionCodeId}
                  endDate={props.endDate}
                  tabIndex={props.tabIndex}
                  objIndex={props.objIndex}
                  resIndex={index}
                  dataColumns={props.dataColumns}
                  stepData={props.stepData}
                  setStepData={props.setStepData}
                  startDate={props.startDate}
                  readOnly={props.readOnly}
                ></ExpectedResult>
              </AEATab>
            );
          })}
        </AEATabs>
      );
    }
    return <div></div>;
  };

  const render = () => {
    if (!Utilities.isNullEmptyObject(props.dataColumns)) {
      return (
        <Container fluid={true}>
          {headerObj()}
          <div style={{position: 'relative'}}>
            {((!objetivesIndicatorGridData?.dataSource || !objetivesIndicatorGridData?.dataSource?.[0]?.Id) && (props.showAlerts || Alerts)) &&
              <div style={{width:"100%", textAlign:"center"}}>
                <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.currentLabels.get("AlertReqEOIndicator")}</h6>
              </div>
            }
            {(objetivesIndicatorGridData?.gridProps?.id && !!objData && !!props.stepData?.[props.objIndex]?.objetives) && 
              <ErrorTable 
                gridId={objetivesIndicatorGridData?.gridProps?.id} 
                showAlerts={Alerts || props.showAlerts}
                checkFunction={presenter.checkRequiredFields}
              />
            }
            {(objetivesIndicatorGridData?.gridProps?.id && !!objData && !!props.stepData?.[props.objIndex]?.objetives && !props.alertEndDate && !Alerts && !props.showAlerts) && 
              <ErrorTable 
                paintColumn
                gridId={objetivesIndicatorGridData?.gridProps?.id} 
                showAlerts={!props.alertEndDate}
                checkFunction={presenter.checkEndDate}
              />
            }
            {!!objData && objData}
          </div>
          <br />
          {resultsAction()}
          {!!resData && resData}
          <Toast
            visible={toastConfig.isVisible}
            message={toastConfig.message}
            type={toastConfig.type}
            onHiding={onHidingToast}
            displayTime={10000}
          />
        </Container>
      );
    }
    return <div></div>;
  };
  return render();
};

export default GeneralData;
